<script setup>
</script>
<template>
  <div class="wrap">
    <slot />
  </div>
</template>
